// extracted by mini-css-extract-plugin
export default {"Container":"ProvidedByLogo_Container__gTyQZ","Text":"ProvidedByLogo_Text__Eb4Sw","Image":"ProvidedByLogo_Image__B-oTn"};